// 실제 CONSTANT는 아니지만 편의상 분류
// ICONS
import vacation_request_icon from "../assets/images/task/vacation_request.svg";
import extend_work_request_icon from "../assets/images/task/extend_work_request.svg";
import holiday_work_request_icon from "../assets/images/task/holiday_work_request.svg";
import other_work_request_icon from "../assets/images/task/other_work_request.svg";
import work_history_request_icon from "../assets/images/task/work_history_request.svg";
import expense_request_icon from "../assets/images/task/expense_request.svg";
import evidence_file_request_icon from "../assets/images/task/evidence_file_request.svg";
import issue_request_icon from "../assets/images/task/issue_request.svg";
import certificate_request_icon from "../assets/images/task/certificate_request.svg";
import year_end_settlement_upload_icon from "../assets/images/task/year_end_settlement_upload.svg";
import common_draft_request_icon from "../assets/images/task/common_draft_request.svg";
import approval_handover_request_icon from "../assets/images/task/approval_handover_request.svg";

// export const LOAD_OPEN_TASK_TYPE = 'common_draft_request';
export const LOAD_OPEN_TASK_TYPE = '';


export const TASK_TYPES = [
  {
    disabled: false,
    isTrial: false,
    label: "휴가 신청",
    createText: "휴가 신청 하시겠습니까?",
    type: "vacation_request",
    postType: "vacation_request",
    icon: vacation_request_icon,
    group: "근무",
  },
  {
    disabled: false,
    isTrial: true,
    label: "연장 근무 신청",
    createText: "연장 근무 신청 하시겠습니까?",
    type: "extend_work_request",
    postType: "work_request",
    icon: extend_work_request_icon,
    group: "근무",
  },
  {
    disabled: false,
    isTrial: true,
    label: "휴일 근무 신청",
    createText: "휴일 근무 신청 하시겠습니까?",
    type: "holiday_work_request",
    postType: "work_request",
    icon: holiday_work_request_icon,
    group: "근무",
  },
  {
    disabled: false,
    isTrial: true,
    label: "기타 근무 신청",
    createText: "기타 근무 신청 하시겠습니까?",
    type: "other_work_request",
    postType: "work_request",
    icon: other_work_request_icon,
    group: "근무",
  },
  {
    disabled: false,
    isTrial: true,
    label: "출퇴근 시간 정정 신청",
    createText: "출퇴근 시간 정정 신청 하시겠습니까?",
    type: "work_history_request",
    postType: "work_request",
    icon: work_history_request_icon,
    group: "근무",
  },
  {
    disabled: false,
    isTrial: false,
    label: "경비 청구",
    createText: "경비 청구 하시겠습니까?",
    type: "expense_request",
    postType: "expense_detail",
    icon: expense_request_icon,
    group: "회계"
  },
  {
    disabled: false,
    isTrial: false,
    label: "증빙 자료 업로드",
    createText: "증빙 자료 업로드 하시겠습니까?",
    type: "evidence_file_request",
    postType: "evidence_file_detail",
    icon: evidence_file_request_icon,
    group: "회계"
  },
  {
    disabled: false,
    isTrial: false,
    label: "발급 요청",
    createText: "발급 요청 하시겠습니까?",
    type: "issue_request",
    postType: "issue_request",
    icon: issue_request_icon,
    group: "회계"
  },
  {
    disabled: false,
    isTrial: false,
    label: "증명서 신청",
    createText: "증명서 신청 하시겠습니까?",
    type: "certificate_request",
    postType: "certificate_request",
    icon: certificate_request_icon,
  },
  {
    disabled: false,
    isTrial: false,
    label: "연말 정산 자료 업로드",
    createText: "연말 정산 자료 업로드 하시겠습니까?",
    type: "year_end_draft_request",
    postType: "year_end_draft",
    icon: year_end_settlement_upload_icon,
  },
  {
    disabled: false,
    isTrial: true,
    label: "일반 기안",
    createText: "일반 기안 신청 하시겠습니까?",
    type: "common_draft_request",
    postType: "common_draft",
    icon: common_draft_request_icon,
  },
  {
    label: "결재위임",
    createText: "결재위임 하시겠습니까?",
    type: "approval_handover_request",
    postType: "approval_handover_detail",
    icon: approval_handover_request_icon,
    hide: true,
  },
];


export const TASK_TYPE_GROUPS = [
  {
    type: "근무",
    label: "근무 관련",
    issues: TASK_TYPES.filter(i => i.group === "근무")
  },
  {
    type: "회계",
    label: "회계 관련",
    issues: TASK_TYPES.filter(i => i.group === "회계")
  },
  {
    type: "기타",
    issues: TASK_TYPES.filter(i => i.group === "기타" || !i.group)
  }
]

export const TASK_STATUS_MENU_LIST = [
  {
    label: "대기중인 할일",
    status: "pending",
    color: 'primary',
  },
  {
    label: "진행중인 할일",
    status: "in_progress",
    color: "warning",
  },
  {
    label: "완료된 할일",
    status: "complete",
    color: "success",
  },
]

export const TASK_STATUS_LIST = [
  {
    status: "pending",
    label: "대기중",
    color: "primary",
  },
  {
    status: "in_progress",
    label: "진행중",
    color: "warning",
  },
  {
    status: "complete",
    label: "승인됨",
    color: "success",
  },
  {
    status: "approved",
    label: "승인됨",
    color: "success",
  },
  {
    status: "denied",
    label: "반려됨",
    color: "danger",
  },
  {
    status: "canceled",
    label: "취소됨",
    color: "secondary",
  },
  {
    status: "reference",
    label: "참조",
    color: "light",
  },
]